import { Card as MuiCard, CardContent as MuiCardContent } from '@mui/material'
import { styled } from '@mui/material/styles'
import { ReactNode } from 'react'
import { useIsIFramed } from '../../hooks'

enum Width {
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

interface Props {
  children: ReactNode
  width?: Width
}

interface ContainerProps {
  width?: Width
}

const Container = styled(MuiCard)`
  width: ${({ width }: ContainerProps) => {
    switch (true) {
      case width === Width.LARGE:
        return '60rem'
      default:
        return '43rem'
    }
  }};
  max-width: calc(100vw - 3rem);
`

const CardContent = styled(MuiCardContent)`
  margin: 0;
  padding: 2rem;
  position: relative;

  &:last-child {
    padding-bottom: 2rem;
  }
`

const Card = ({ children, width = Width.MEDIUM }: Props) => {
  const isIFramed = useIsIFramed()

  if (isIFramed) {
    return <>{children}</>
  }

  return (
    <Container width={width}>
      <CardContent>{children}</CardContent>
    </Container>
  )
}

export { Card, Width }
